module.exports = __webpack_public_path__ + "static/media/skill_modifier.c7530bcb.png";